import buildScriptQueue from 'ads/utils/buildScriptQueue';

export default buildScriptQueue({
  globalVar: 'googletag',
  queueKey: 'cmd',
  scopedName: 'googleTag',
});
